var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.bemBlock, attrs: { id: "vue-the-product-list" } },
    [
      _c("TheProductListHeader", {
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          "breadcrumb-not-as-h1": _vm.breadcrumbNotAsH1
        }
      }),
      _vm._v(" "),
      _c("TheProductListFilters", {
        class: _vm.bemElement("filters"),
        on: {
          "filter-applied": function() {
            return (_vm.filterApplied = true)
          },
          "filter-cleared": function() {
            return (_vm.filterApplied = false)
          }
        }
      }),
      _vm._v(" "),
      _vm.categoryTopMessage
        ? _c("div", {
            class: _vm.bemElement("top-message"),
            domProps: { innerHTML: _vm._s(_vm.categoryTopMessage) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("BaseProductGrid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.productSearchHasProducts,
            expression: "productSearchHasProducts"
          }
        ],
        class: _vm.bemElement("product-grid"),
        attrs: {
          analytics: {
            category: _vm.category,
            location: _vm.analyticsConst.location.plpGrid
          },
          "column-mode": _vm.columnMode,
          products: _vm.products,
          type: "productList",
          "bottom-spinner": _vm.bottomSpinner,
          "header-height": _vm.headerHeight,
          "infinite-next": !_vm.btnNextPageEnabled,
          "infinite-previous": true
        },
        on: {
          "infinite:next": _vm.handleCaptureNextPage,
          "infinite:previous": _vm.previousPage,
          "category-shown": _vm.handleCategoryShown
        },
        scopedSlots: _vm._u([
          {
            key: "afterList",
            fn: function() {
              return [
                _c("p", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLastPage,
                      expression: "isLastPage"
                    }
                  ],
                  class: [
                    _vm.bemElement("description"),
                    { "visually-hidden": !_vm.isLastPage }
                  ],
                  domProps: { innerHTML: _vm._s(_vm.description) }
                }),
                _vm._v(" "),
                _vm.btnNextPageEnabled &&
                _vm.currentStateNextPage &&
                _vm.productSearchHasProducts &&
                !_vm.isLastPage
                  ? _c(
                      "div",
                      { class: _vm.bemElement("container-next-page") },
                      [
                        _c("BaseSpinner", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          attrs: { inline: "" }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.loading,
                                expression: "!loading"
                              }
                            ],
                            class: [_vm.bemElement("btn-next-page"), "btn"],
                            attrs: {
                              "aria-label": _vm.$msg(
                                "productList.nextPageBtnDescription",
                                "productList"
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.nextPage(_vm.currentStateNextPage)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$msg(
                                    "productList.nextPageBtn",
                                    "productList"
                                  )
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      !_vm.loading && !_vm.productSearchHasProducts
        ? _c("div", { class: [_vm.bemElement("empty")] }, [
            _c("p", { class: [_vm.bemElement("empty-text")] }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$msg("productList.empty.text", "productList")) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                class: [
                  _vm.bemElement("empty-button"),
                  "btn",
                  {
                    "btn--cta": _vm.isBreakpointMobile,
                    "btn-primary": !_vm.isBreakpointMobile
                  }
                ],
                on: { click: _vm.handleEmptyButtonClick }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$msg("productList.clearfilters.text", "productList")
                    ) +
                    "\n    "
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }